import * as types from "../constants/action-types";

export const initialState = {
  hasBypassedPuzzles: false,
  activePuzzle: "diamond",
  solvedPuzzles: []
};

export default (state = initialState, action) => {
  switch (action.type) {
    case types.PUZZLE_SOLVED:
      if (state.solvedPuzzles.indexOf(action.puzzle) !== -1) {
        return initialState;
      }
      return Object.assign({}, state, {
        solvedPuzzles: [...state.solvedPuzzles, action.puzzle]
      });
    case types.SET_ACTIVE_PUZZLE:
      return Object.assign({}, state, {
        activePuzzle: action.puzzle
      });
    case types.SKIP_PUZZLES:
      return Object.assign({}, state, {
        hasBypassedPuzzles: true
      });
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/puzzles.js